import { Control, Controller, FieldErrors } from "react-hook-form";
import { TextInput } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { MAX_PRICE_VALUE } from "@jugl-web/domain-resources/tasks/components/AddNewProductForm/consts";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { ServiceFormValues } from "../../types";

interface ComponentProps {
  control: Control<ServiceFormValues>;
  errors?: FieldErrors<ServiceFormValues>;
  isItem?: boolean;
}

export const PriceField = ({ control, errors, isItem }: ComponentProps) => {
  const { entity } = useEntitySelectedProvider();

  const { t } = useTranslations();

  return (
    <div className="w-full">
      <Controller
        control={control}
        name="price"
        rules={{
          validate: (value) => {
            if (Number(value) > MAX_PRICE_VALUE) {
              return t(
                {
                  id: "inventory-item-form-page.price-too-high",
                  defaultMessage: "Max value is {maxPriceValue}",
                },
                {
                  maxPriceValue: MAX_PRICE_VALUE,
                }
              );
            }
            if (!value) {
              return t({
                id: "inventory-item-form-page.mandatory-field",
                defaultMessage: "Mandatory field",
              });
            }
            return true;
          },
        }}
        render={({ field: { value, onChange } }) => (
          <TextInput
            placeholder={t({
              id: "common.enter",
              defaultMessage: "Enter",
            })}
            onKeyDown={(e) => {
              const notAllowedCharacters = ["e", "E", "+", "-"];
              if (notAllowedCharacters.includes(e.key)) {
                e.preventDefault();
              }
            }}
            type="number"
            min={0}
            max={MAX_PRICE_VALUE}
            step={1}
            onBlur={() => {
              if (value) {
                const numValue =
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore TODO: fix it, value is not string
                  value.value !== undefined ? value.value : value;
                const isNaN = Number.isNaN(Number(numValue));
                onChange(isNaN ? "" : parseFloat(numValue).toFixed(2));
              }
            }}
            isInvalid={!!errors?.price}
            label={
              isItem
                ? t({
                    id: "inventory-item-form-page.price-unit",
                    defaultMessage: "Price/unit",
                  })
                : t({
                    id: "inventory-item-form-page.price",
                    defaultMessage: "Price",
                  })
            }
            onChange={(e) => onChange(e.target.value)}
            isRequired
            errorMessage={errors?.price?.message}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TODO: fix it, value is not string
            value={value.value !== undefined ? value.value : value}
            endContent={
              <div className="font-secondary text-dark text-base">
                {entity.currency}
              </div>
            }
          />
        )}
      />
    </div>
  );
};
